export default __webpack_public_path__ + "static/media/bg_tab.076ee681.png";